<template>
  <AppToggleDropdown
    direction="right"
    trigger-classes="dropdown-toggle"
  >
    <template slot="trigger">
      <a class="btn btn-primary">
        <span>Add policy</span>
        <i class="hi hi-caret hi-10 add-policy"></i>
      </a>
    </template>
    <li
      v-for="item in permittedItems"
      :key="item.name"
    >
      <a
        :class="item.class"
        :href="item.href"
        @click="item.handler"
      >
        <div
          v-if="item.showSilentAppPill"
          class="coming-soon"
        >
          Silent app add-on
        </div>
        <div class="name">{{ item.name }}</div>
        <div class="description">{{ item.description }}</div>
      </a>
    </li>
  </AppToggleDropdown>
</template>

<script>
export default {
  name: 'AutoTrackRulesDropdown',
  props: {
    showSilentAppPill: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    permittedItems() {
      return this.items.filter((item) => item.permitted);
    },
    items() {
      return [
        {
          name: 'For member-owned computers',
          description: 'Members can access the app and data',
          handler: () => this.$emit('open-dialog', 'standard'),
          permitted: true,
          showSilentAppPill: false,
          class: 'add-policy-option',
        },
        {
          name: 'For company-owned computers',
          description: 'Silent app runs only in background',
          handler: () => this.$emit('open-dialog', 'corporate'),
          permitted: true,
          showSilentAppPill: this.showSilentAppPill,
          class: 'add-policy-option',
        },
      ];
    },
  },
};
</script>
